import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowRight, Save, Loader2 } from 'lucide-react';
import { useCreateCustomer } from '../hooks/useCustomers';

const API_URL = 'https://targetexpress.secretofthedesert.com/api';

const EGYPT_REGIONS: { [key: string]: { nameAr: string; areas: string[] } } = {
  "Cairo": { 
    nameAr: "القاهرة", 
    areas: ["مصر الجديدة", "مدينة نصر", "التجمع الخامس", "المعادي", "شبرا", "وسط البلد", "حلوان", "المرج", "عين شمس", "الوايلي", "المطرية", "الزيتون", "حدائق القبة", "الجمالية", "بابل الشعرية", "بدر", "الشروق", "القاهرة الجديدة", "الرحاب", "مدينتي"] 
  },
  "Giza": { 
    nameAr: "الجيزة", 
    areas: ["الدقي", "المهندسين", "الهرم", "فيصل", "6 أكتوبر", "الشيخ زايد", "العجوزة", "العمرانية", "البدرشين", "الحوامدية", "العياط", "أطفيح", "أبو النمرس", "كرداسة", "الوراق", "إمبابة", "الصف", "الواحات البحرية"] 
  },
  "Alexandria": { 
    nameAr: "الإسكندرية", 
    areas: ["سموحة", "المنتزه", "المعمورة", "السيوف", "العجمي", "محرم بك", "الشاطبي", "سيدي بشر", "العصافرة", "ميامي", "برج العرب", "اللبان", "المنشية", "الجمرك", "كرموز", "العامرية"] 
  },
  "Qalyubia": { 
    nameAr: "القليوبية", 
    areas: ["بنها", "شبرا الخيمة", "قليوب", "الخانكة", "العبور", "قها", "طوخ", "شبين القناطر", "كفر شكر", "قليوب المحطة", "الخصوص"] 
  },
  "Dakahlia": { 
    nameAr: "الدقهلية", 
    areas: ["المنصورة", "ميت غمر", "السنبلاوين", "طلخا", "دكرنس", "بلقاس", "المنزلة", "شربين", "بني عبيد", "أجا", "تمي الأمديد", "الجمالية مصر", "المطرية دقهلية"] 
  },
  "Gharbia": { 
    nameAr: "الغربية", 
    areas: ["طنطا", "المحلة الكبرى", "كفر الزيات", "زفتى", "بسيون", "سمنود", "قطور", "السنطة"] 
  },
  "Sharqia": { 
    nameAr: "الشرقية", 
    areas: ["الزقازيق", "العاشر من رمضان", "بلبيس", "فاقوس", "أبو حماد", "منيا القمح", "الحسينية", "أبو كبير", "كفر صقر", "أولاد صقر", "مشتول السوق", "ديررب نجم", "القرين", "الصالحية الجديدة"] 
  },
  "Monufia": { 
    nameAr: "المنوفية", 
    areas: ["شبين الكوم", "قويسنا", "أشمون", "مدينة السادات", "منوف", "تلا", "الشهداء", "الباجور", "بركة السبع", "سرس الليان"] 
  },
  "Beheira": { 
    nameAr: "البحيرة", 
    areas: ["دمنهور", "كفر الدوار", "إيتاي البارود", "رشيد", "كوم حمادة", "أبو حمص", "حوش عيسى", "أبو المطامير", "إدكو", "الدلنجات", "المحمودية", "وادي النطرون", "بدر بحيرة"] 
  },
  "Kafr El-Sheikh": { 
    nameAr: "كفر الشيخ", 
    areas: ["كفر الشيخ المدينة", "دسوق", "قلين", "سيدي سالم", "بيلا", "بلطيم", "مطوبس", "الحامول", "فوه", "الرياض"] 
  },
  "Damietta": { 
    nameAr: "دمياط", 
    areas: ["دمياط المدينة", "دمياط الجديدة", "رأس البر", "فارسكور", "الزرقا", "كفر سعد", "كفر البطيخ", "عزبة البرج"] 
  },
  "Port Said": { 
    nameAr: "بور سعيد", 
    areas: ["حي الشرق", "حي العرب", "حي المناخ", "حي الضواحي", "بورفؤاد", "حي الزهور", "حي الجنوب", "حي الغرب"] 
  },
  "Ismailia": { 
    nameAr: "الإسماعيلية", 
    areas: ["الإسماعيلية المدينة", "الفايد", "القنطرة غرب", "القنطرة شرق", "القصاصين", "التل الكبير", "أبو صوير"] 
  },
  "Suez": { 
    nameAr: "السويس", 
    areas: ["حي السويس", "حي الأربعين", "حي عتاقة", "حي الجناين", "حي فيصل"] 
  },
  "Fayoum": { 
    nameAr: "الفيوم", 
    areas: ["الفيوم المدينة", "سنورس", "إبشواي", "طامية", "إطسا", "يوسف الصديق", "الفيوم الجديدة"] 
  },
  "Beni Suef": { 
    nameAr: "بني سويف", 
    areas: ["بني سويف المدينة", "بني سويف الجديدة", "الواسطى", "ناصر", "ببا", "الفشن", "سمسطا", "اهناسيا"] 
  },
  "Minya": { 
    nameAr: "المنيا", 
    areas: ["المنيا المدينة", "ملوي", "بني مزار", "مغاغة", "سمالوط", "أبو قرقاص", "دير مواس", "مطاي", "العدوة", "المنيا الجديدة"] 
  },
  "Asyut": { 
    nameAr: "أسيوط", 
    areas: ["أسيوط المدينة", "ديروط", "منفلوط", "القوصية", "أبو تيج", "أبنوب", "الفتح", "ساحل سليم", "البداري", "صدفا", "الغنايم", "أسيوط الجديدة"] 
  },
  "Sohag": { 
    nameAr: "سوهاج", 
    areas: ["سوهاج المدينة", "أخميم", "جرجا", "طما", "طهطا", "البلينا", "المنشأة", "المراغة", "جهينة", "دار السلام سوهاج", "ساقلتة", "سوهاج الجديدة"] 
  },
  "Qena": { 
    nameAr: "قنا", 
    areas: ["قنا المدينة", "نجع حمادي", "دشنا", "قوص", "أبو تشت", "قفط", "نقادة", "فرشوط", "الوقف", "قنا الجديدة"] 
  },
  "Luxor": { 
    nameAr: "الأقصر", 
    areas: ["الأقصر المدينة", "البياضية", "القرنة", "أرمنت", "إسنا", "الطود", "طيبة الجديدة"] 
  },
  "Aswan": { 
    nameAr: "أسوان", 
    areas: ["أسوان المدينة", "كوم أمبو", "إدفو", "نصر النوبة", "أبو سمبل", "دراو", "أسوان الجديدة"] 
  },
  "Red Sea": { 
    nameAr: "البحر الأحمر", 
    areas: ["الغردقة", "سفاجا", "القصير", "مرسى علم", "رأس غارب", "شلاتين", "حلايب"] 
  },
  "Matrouh": { 
    nameAr: "مرسى مطروح", 
    areas: ["مرسى مطروح المدينة", "العميد", "الضبعة", "العلمين", "سيدي براني", "سيوة", "الحمام", "السلوم", "النجيلة"] 
  },
  "North Sinai": { 
    nameAr: "شمال سيناء", 
    areas: ["العريش", "الشيخ زويد", "رفح", "بئر العبد", "الحسنة", "نخل"] 
  },
  "South Sinai": { 
    nameAr: "جنوب سيناء", 
    areas: ["شرم الشيخ", "طور سيناء", "دهب", "نويبع", "طابا", "رأس سدر", "سانت كاترين", "أبو رديس", "أبو زنيمة"] 
  },
  "New Valley": { 
    nameAr: "الوادي الجديد", 
    areas: ["الخارجة", "الداخلة", "الفرافرة", "باريس", "بلاط"] 
  }
};

export default function CreateCustomerPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const isEditMode = !!id;
  const createMutation = useCreateCustomer();
  const [error, setError] = useState('');
  const [loadingData, setLoadingData] = useState(false);

  const [formData, setFormData] = useState({
    name: '', phone: '', email: '', address: '',
    city: 'Cairo', area: 'مصر الجديدة', status: 'نشط', commercialRegister: ''
  });

  useEffect(() => {
    if (isEditMode) {
      setLoadingData(true);
      const token = localStorage.getItem('token');
      fetch(`${API_URL}/customers/${id}`, { headers: { 'Authorization': `Bearer ${token}` } })
        .then(res => res.json())
        .then(res => {
          const data = res?.data || res;
          if (data) {
            setFormData({
              name: data.name || '',
              phone: data.phone || '',
              email: data.email || '',
              address: data.address || '',
              city: EGYPT_REGIONS[data.city] ? data.city : 'Cairo',
              area: data.area || 'مصر الجديدة',
              status: data.status || 'نشط',
              commercialRegister: data.commercialRegister || ''
            });
          }
        })
        .catch(err => setError(err.message || 'فشل في جلب بيانات العميل'))
        .finally(() => setLoadingData(false));
    }
  }, [id, isEditMode]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const payload = { ...formData, storeName: formData.name };
      const url = isEditMode ? `${API_URL}/customers/${id}` : `${API_URL}/customers`;
      const method = isEditMode ? 'PUT' : 'POST';

      if (isEditMode) {
        const r = await fetch(url, { 
          method, 
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }, 
          body: JSON.stringify(payload) 
        });
        if (!r.ok) throw new Error();
        alert('تم تعديل بيانات العميل بنجاح');
      } else {
        await createMutation.mutateAsync(payload);
        alert('تم تسجيل العميل بنجاح');
      }
      navigate('/customers');
    } catch {
      setError('حدث خطأ أثناء حفظ بيانات العميل');
    }
  };

  if (loadingData) return <div className="p-12 text-center" dir="rtl"><Loader2 className="animate-spin inline-block ml-2" /> جاري التحميل...</div>;

  const currentCity = EGYPT_REGIONS[formData.city] ? formData.city : 'Cairo';
  const availableAreas = EGYPT_REGIONS[currentCity]?.areas || [];

  return (
    <div className="space-y-6" dir="rtl">
      <div className="flex items-center gap-3">
        <button type="button" onClick={() => navigate(-1)} className="p-2"><ArrowRight size={20} /></button>
        <h1 className="text-2xl font-bold">{isEditMode ? 'تعديل بيانات العميل' : 'إضافة عميل جديد'}</h1>
      </div>
      {error && <div className="p-4 text-red-700 bg-red-50 rounded-lg">{error}</div>}
      <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-sm border p-6 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div><label className="block text-xs font-bold mb-2">اسم العميل / الشركة *</label><input type="text" required className="w-full border p-2.5 bg-gray-50 rounded-xl text-xs" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} /></div>
          <div><label className="block text-xs font-bold mb-2">رقم الهاتف *</label><input type="text" required className="w-full border p-2.5 bg-gray-50 rounded-xl text-xs" value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} /></div>
          <div><label className="block text-xs font-bold mb-2">البريد الإلكتروني</label><input type="email" className="w-full border p-2.5 bg-gray-50 rounded-xl text-xs" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} /></div>
          <div><label className="block text-xs font-bold mb-2">السجل التجاري / الرقم الضريبي</label><input type="text" className="w-full border p-2.5 bg-gray-50 rounded-xl text-xs" value={formData.commercialRegister} onChange={e => setFormData({...formData, commercialRegister: e.target.value})} /></div>
          <div><label className="block text-xs font-bold mb-2">المحافظة</label><select className="w-full border p-2.5 bg-gray-50 rounded-xl text-xs" value={currentCity} onChange={e => { const c = e.target.value; setFormData({...formData, city: c, area: EGYPT_REGIONS[c].areas[0]}); }} >{Object.keys(EGYPT_REGIONS).map(k => <option key={k} value={k}>{EGYPT_REGIONS[k].nameAr}</option>)}</select></div>
          <div><label className="block text-xs font-bold mb-2">المنطقة الرئيسية</label><select className="w-full border p-2.5 bg-gray-50 rounded-xl text-xs" value={formData.area} onChange={e => setFormData({...formData, area: e.target.value})} >{availableAreas.map(a => <option key={a} value={a}>{a}</option>)}</select></div>
          <div className="md:col-span-2"><label className="block text-xs font-bold mb-2">العنوان بالتفصيل *</label><input type="text" required className="w-full border p-2.5 bg-gray-50 rounded-xl text-xs" value={formData.address} onChange={e => setFormData({...formData, address: e.target.value})} /></div>
        </div>
        <div className="flex justify-end gap-3 border-t pt-4">
          <button type="button" onClick={() => navigate(-1)} className="px-4 py-2 text-xs border rounded-xl">إلغاء</button>
          <button type="submit" className="px-5 py-2 text-xs text-white bg-orange-600 rounded-xl font-bold flex items-center gap-1"><Save size={14} /> حفظ بيانات العميل</button>
        </div>
      </form>
    </div>
  );
}
